'use client';

import { Toaster } from 'sonner';
import { DataProvider } from "@/context/DataContext";
import { AuthProvider } from "@/context/AuthContext";
import { CookieConsent } from '@/components/cookies/cookie_consent';
import { ReactNode } from 'react';
import { ActivityTracker } from '@/components/auth/activity_tracker';
import { ThemeProvider } from '@/components/general/theme_provider';
import { SidebarProvider } from '@/components/ui/custom-sidebar';
import { SidebarMenuProvider } from '@/components/general/SidebarMenuProvider';
import { SearchProvider } from '@/components/search/SearchContext'
import { User } from "@/models/data_models";

export function Providers({
  children,
  initialUser,
}: {
  children: ReactNode;
  initialUser: User | null;
}) {

  return (
    <CookieConsent>
      <AuthProvider initialUser={initialUser}>
        <ActivityTracker>
          <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
          >
            <SearchProvider>
              <DataProvider>
                <SidebarProvider>
                  <SidebarMenuProvider>
                    {children}
                  </SidebarMenuProvider>
                </SidebarProvider>
              </DataProvider>
            </SearchProvider>
          </ThemeProvider>
        </ActivityTracker>
      </AuthProvider>
      <Toaster
        position="bottom-right"
      />
    </CookieConsent>
  );
}
